import  {FETCH_CLASS} from  './ActionTypes';
import api from '../api'
import { MESSAGE } from "../helpers/constants"
import { toast } from 'react-toastify';

export function fetchClass(router, data) {
	return function (dispatch) {        
        api.get("classes").then(async (response) => {
        //console.log("***************************",JSON.stringify(response))
            if (response.status === "success") {
                await dispatch({
                    type: FETCH_CLASS,
                    data: response.payload
                });
            }
        })
    }
}

export function addClass(router,classValues) {
	return function (dispatch) {        
        api.post("classes", classValues).then(async (response) => {
            if (response.status === "success") {
                api.get("classes").then(async (response) => {
                    if (response.status === "success") {
                        await dispatch({
                            type: FETCH_CLASS,
                            data: response.payload
                        });
                    } 
                    toast.success(MESSAGE.classMessage, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    }); 
               })
            }
        })
    }
}

export function updateClass(classes,id){
	return function(dispatch){
       // console.log("===ssss=classupdate==="+JSON.stringify(classes));
		api.put("classes/"+id, classes).then(async (response) => {
            //console.log("===ssss=classupdate==="+JSON.stringify(response));
            if (response.status === "success") {
                api.get("classes").then(async (response) => {
                //console.log("====classupdate==="+JSON.stringify(response));
                    if (response.status === "success") {
                        await dispatch({
                            type: FETCH_CLASS,
                            data: response.payload
                        });
                        toast.success(MESSAGE.classUpdateMessage, {
                            position: toast.POSITION.BOTTOM_RIGHT
                        }); 
                    }
                })
            }
           
		})
	}
}



